import styled from 'styled-components';

export const TableContainer = styled.div`
  .multiplicity-row > td {
    background-color: #fff7e6;
  }

  .multiplicity-row:hover > td {
    background-color: #ffe7ba !important;
  }
`;
